import { footerItems } from '../../data/Sitemap';

// Define the NavItem type for clarity
interface NavItem {
  label: string;
  path: string;
  type?: string;
  icon?: string;
  desc?: string;
  nav?: 'hide' | 'show';
  subLinks?: NavItem[];
}

// Recursive function to flatten navigation items
export const getLinearNavPath = (): NavItem[] => {
  const linearNav: NavItem[] = [];

  const traverseNavItems = (items: NavItem[]) => {
    items.forEach((item: NavItem) => {
      if (item.nav !== 'hide') {
        linearNav.push(item);
        if (item.subLinks) {
          traverseNavItems(item.subLinks);
        }
      }
    });
  };

  traverseNavItems(footerItems as NavItem[]);

  return linearNav;
};

// Function to find the previous and next items
export const getPrevNextItems = (currentPath: string) => {
  const linearNav = getLinearNavPath();
  const currentIndex = linearNav.findIndex((item) => item.path === currentPath);

  const prevItem = currentIndex > 0 ? linearNav[currentIndex - 1] : null;
  const nextItem =
    currentIndex < linearNav.length - 1 ? linearNav[currentIndex + 1] : null;

  return { prevItem, nextItem };
};
